/* VVS CLUB – launch / password page */
(() => {
  const root = document.getElementById('vvs-pw');
  if (!root) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  root.querySelectorAll('[data-vvs-split]').forEach((el) => {
    const text = el.textContent;
    el.setAttribute('aria-label', text);
    el.textContent = '';
    let i = 0;
    for (const ch of text) {
      const s = document.createElement('span');
      s.setAttribute('aria-hidden', 'true');
      s.textContent = ch === ' ' ? ' ' : ch;
      s.style.setProperty('--i', i++);
      el.appendChild(s);
    }
  });

  const gemBox = root.querySelector('[data-vvs-gems]');
  const count = Number(root.dataset.gems) || 0;
  const GEM = '<svg viewBox="0 0 24 24"><path d="M6.5 3.5h11l3.5 5.5L12 20.5 3 9z"/><path d="M3 9h18"/><path d="M9.5 3.5L8 9l4 11.5L16 9l-1.5-5.5"/></svg>';
  const SPARK = '<svg viewBox="0 0 24 24"><path d="M12 0l2.6 9.4L24 12l-9.4 2.6L12 24l-2.6-9.4L0 12l9.4-2.6z"/></svg>';
  const rnd = (a, b) => a + Math.random() * (b - a);
  if (gemBox && !reduce) {
    for (let i = 0; i < count; i++) {
      const spark = i % 2 === 1;
      const n = document.createElement('span');
      n.className = spark ? 'vvs-spark' : 'vvs-gem';
      n.innerHTML = spark ? SPARK : GEM;
      n.style.left = rnd(2, 96) + '%';
      n.style.top = rnd(5, 92) + '%';
      if (spark) {
        n.style.setProperty('--sz', rnd(6, 16).toFixed(0) + 'px');
        n.style.setProperty('--d', rnd(2.4, 5).toFixed(2) + 's');
        n.style.setProperty('--delay', rnd(0, 6).toFixed(2) + 's');
      } else {
        const size = rnd(14, 46);
        n.style.width = n.style.height = size.toFixed(0) + 'px';
        n.style.setProperty('--d', rnd(9, 18).toFixed(2) + 's');
        n.style.setProperty('--delay', rnd(0, 9).toFixed(2) + 's');
        n.style.setProperty('--o', rnd(0.12, 0.35).toFixed(2));
        n.style.setProperty('--dx', rnd(-60, 60).toFixed(0) + 'px');
        n.style.setProperty('--r', rnd(-120, 120).toFixed(0) + 'deg');
      }
      gemBox.appendChild(n);
    }
  }

  const glow = root.querySelector('[data-vvs-cursor]');
  const logo = root.querySelector('.vvs-pw__logo');
  if (!reduce && window.matchMedia('(hover: hover)').matches) {
    let raf = 0, mx = 0, my = 0;
    root.addEventListener('pointermove', (e) => {
      mx = e.clientX; my = e.clientY;
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        if (glow) glow.style.transform = 'translate3d(' + mx + 'px,' + (my + root.scrollTop) + 'px,0)';
        if (logo) {
          const dx = (mx / window.innerWidth - 0.5) * 2, dy = (my / window.innerHeight - 0.5) * 2;
          logo.style.transform = 'perspective(800px) rotateY(' + (dx * 6).toFixed(2) + 'deg) rotateX(' + (-dy * 6).toFixed(2) + 'deg)';
        }
      });
    });
  }

  const cd = root.querySelector('[data-vvs-cd]');
  const target = Date.parse(root.dataset.launch || '');
  const pad = (n) => String(n).padStart(2, '0');
  const last = {};
  function tick() {
    if (!cd || isNaN(target)) return;
    const diff = Math.max(0, target - Date.now());
    if (diff === 0) {
      cd.classList.add('vvs-cd--done');
      const d = root.querySelector('[data-vvs-date]');
      if (d) d.textContent = root.dataset.done || '';
      return;
    }
    const vals = {
      d: Math.floor(diff / 86400000),
      h: Math.floor(diff / 3600000) % 24,
      m: Math.floor(diff / 60000) % 60,
      s: Math.floor(diff / 1000) % 60
    };
    for (const k in vals) {
      const el = cd.querySelector('[data-u="' + k + '"]');
      const v = pad(vals[k]);
      if (el && last[k] !== v) {
        el.textContent = v;
        if (last[k] !== undefined && !reduce) { el.classList.remove('tick'); void el.offsetWidth; el.classList.add('tick'); }
        last[k] = v;
      }
    }
    setTimeout(tick, 1000 - (Date.now() % 1000));
  }
  tick();

  const comp = document.getElementById('password-form');
  const pd = comp && comp.querySelector('dialog');
  const ownerBtn = root.querySelector('[data-vvs-owner]');
  if (ownerBtn) {
    ownerBtn.addEventListener('click', () => {
      if (comp && typeof comp.showDialog === 'function') comp.showDialog();
      else if (pd && !pd.open) pd.showModal();
      setTimeout(() => { const f = document.getElementById('Password'); if (f) f.focus(); }, 60);
    });
  }
  /* wrong password: the theme opens the dialog non-modal, which would sit under our fixed layer */
  if (pd && pd.open && !pd.matches(':modal')) { pd.close(); pd.showModal(); }

  /* Email form: client-side check + friendly "try again" messages */
  const form = root.querySelector('#vvs-pw-form');
  const field = root.querySelector('.vvs-pw__field');
  const input = root.querySelector('#vvs-pw-email');
  const errBox = root.querySelector('[data-vvs-err]');
  const errText = root.querySelector('[data-vvs-err-text]');
  const EMAIL = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)*\.[a-z]{2,}$/i;
  const shake = () => { if (!field || reduce) return; field.classList.remove('is-shake'); void field.offsetWidth; field.classList.add('is-shake'); };
  const showErr = (msg) => {
    if (msg && errText) errText.textContent = msg;
    if (errBox) errBox.hidden = false;
    if (field) field.classList.add('is-invalid');
    if (input) input.setAttribute('aria-invalid', 'true');
    shake();
  };
  const clearErr = () => {
    if (errBox) errBox.hidden = true;
    if (field) field.classList.remove('is-invalid');
    if (input) input.removeAttribute('aria-invalid');
  };
  if (form && input) {
    form.addEventListener('submit', (e) => {
      const v = input.value.trim();
      input.value = v;
      if (!EMAIL.test(v)) { e.preventDefault(); showErr(root.dataset.errInvalid); input.focus(); }
    });
    input.addEventListener('input', clearErr);
  }

  /* After a submit (success or server error), show the form right away and keep it in view */
  const ok = root.querySelector('.vvs-pw__ok');
  const serverErr = errBox && !errBox.hidden;
  if (ok || serverErr) {
    root.classList.add('is-posted');
    root.querySelector('.vvs-pw__form').scrollIntoView({ block: 'center' });
    if (serverErr) { shake(); if (input) input.focus({ preventScroll: true }); }
  }
})();